<ng-container *ngIf="lineStatus$ | async as lineStatus">
   <fa-icon
      kendoTooltip
      [title]="lineStatus.lineStatus.translationKey | translate"
      class="sam-margin-right"
      [ngClass]="lineStatus.lineStatus.styleClass"
      [class.state-forwarded-and-idle]="isForwardedAndIdle(lineStatus.lineStatus, lineStatus.lineState)"
      [icon]="lineStatus.lineStatus.statusIcon"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
   <ng-container *ngIf="lineStatus?.lineState?.connectedId">
      <div
         class="sam-margin-right"
         [translate]="lineStatus?.lineStatus.translationKeyWithConnectedId"
         [translateParams]="{ connectedId: lineStatus.lineState.connectedId }"
      ></div>
   </ng-container>
   <ng-container *ngIf="!lineStatus?.lineState?.connectedId && lineStatus?.lineStatus.displayTextDefault">
      <div class="sam-margin-right">{{ lineStatus?.lineStatus.translationKey | translate }}</div>
   </ng-container>
   <ng-container *ngIf="lineStatus?.lineState?.fwd">
      <div
         [translate]="'samwin.contact-status.general.post-forwarded-to-text'"
         [translateParams]="{ forwardNumber: lineStatus.lineState.fwd }"
      ></div>
   </ng-container>
</ng-container>
<ng-container *ngIf="!(lineStatus$ | async) as lineStatus">
   <fa-icon
      kendoTooltip
      class="sam-margin-right"
      [title]="lineStatus.lineStatus.translationKey | translate"
      [ngClass]="lineStatus.lineStatus.styleClass"
      [class.state-forwarded-and-idle]="isForwardedAndIdle(lineStatus.lineStatus, lineStatus.lineState)"
      [icon]="lineStatus.lineStatus.statusIcon"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
</ng-container>
